import { createFeatureSelector, createSelector } from "@ngrx/store";
import { ProductsState } from "./products.reducers";
import { Product } from "../../class/product.class";
import { ProductModel, Products } from "../../models/products.models";

export const selectProductsState = createFeatureSelector<ProductsState>('products');

export const selectAllProducts = createSelector(
  selectProductsState,
  (state: ProductsState) => state.products
);

export const selectFreeProduct = createSelector(
  selectProductsState,
  (data: ProductsState) => data.products?.free ? new Product(data.products.free) : null
);

export const selectProProduct = createSelector(
  selectProductsState,
  (data: ProductsState) => data.products?.pro ? new Product(data.products.pro) : null
);

export const selectEntrepriseProduct = createSelector(
  selectProductsState,
  (data: ProductsState) => data.products?.entreprise ? new Product(data.products.entreprise) : null
);

export const selectProductById = (productId: string, periodicity: 'year' | 'month') => createSelector(
  selectProductsState,
  (state: ProductsState) => {
    if (!state.products) return null;
    const productObj = Object.values(state.products).find(
      (p: ProductModel) => new Product(p).getPricesIdByPerdiodicity(periodicity) === productId
    );
    return productObj ? new Product(productObj) : null;
  }
);
